import { useTranslation } from '@msdk/common'
import { styled, uiTokens } from '@msdk/ui'
import { useWizard } from 'react-use-wizard'

import { FooterPopup } from './FooterPopup'
import { GeneratedCodeField } from './GeneratedCodeField'
import { HeaderPopup } from './HeaderPopup'
import {
  ModalStepProps,
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
  StyledEditContent,
  StyledMessageTypography,
  StyledSummaryTypography,
} from './shared'

const StyledListItem = styled('li')`
  padding: ${uiTokens.spacing.padding.small}px ${uiTokens.spacing.padding.xSmall}px;
  gap: ${uiTokens.spacing.gap.small}px;
  color: ${uiTokens.uiContent.emphasized};
  font-family: ${uiTokens.font.fontFamily.default};
  font-size: ${uiTokens.font.fontSize.uiControlText.medium}px;
  font-style: normal;
  font-weight: ${uiTokens.font.fontWeight.medium};
  line-height: ${uiTokens.font.lineHeight.uiControlText.medium}px; /* 128.571% */
  letter-spacing: ${uiTokens.font.letterSpacing.normal}px;
`

const StyledList = styled('ol')`
  padding: ${uiTokens.spacing.padding.small}px ${uiTokens.spacing.padding.medium}px ${uiTokens.spacing.padding.medium}px
    ${uiTokens.spacing.padding.medium}px;
`

export function NFCGeneratedCodePopup(props: ModalStepProps) {
  const { goToStep } = useWizard()
  const t = useTranslation()

  return (
    <>
      <HeaderPopup title={t('LBL_NGID_NFC_CARD_TITLE', 'NFC card')} modalRef={props.modalRef} />
      <StyledEditContent>
        <StyledMessageTypography variant="body1">
          {t(
            'LBL_NGID_NFC_CARD_CODE_DESCR',
            'Use generated activation code and finish the setup at the dialysis machine.',
          )}
        </StyledMessageTypography>
        <GeneratedCodeField codeType="nfc" />
        <StyledAccordion>
          <StyledAccordionSummary aria-controls="panel2-content" id="panel2-header">
            <StyledSummaryTypography>
              {t('LBL_NGID_NFC_CARD_GUIDLINES_TITLE', 'NFC card activation')}
            </StyledSummaryTypography>
          </StyledAccordionSummary>
          <StyledAccordionDetails>
            <StyledList>
              <StyledListItem>
                {t('LBL_NGID_NFC_CARD_GUIDLINES_DESCR1', `Go to dialysis machine and select 'user enrollment'.`)}
              </StyledListItem>
              <StyledListItem>
                {t('LBL_NGID_NFC_CARD_GUIDLINES_DESCR2', 'Select NFC card option and enter activation code.')}
              </StyledListItem>
              <StyledListItem>
                {t(
                  'LBL_NGID_NFC_CARD_GUIDLINES_DESCR3',
                  'Follow the instructions on the machine screen to complete the process.',
                )}
              </StyledListItem>
            </StyledList>
          </StyledAccordionDetails>
        </StyledAccordion>
      </StyledEditContent>
      <FooterPopup primary={{ label: t('LBL_NGID_DONE_BTN', 'Done'), onClick: () => goToStep(3) }} />
    </>
  )
}
